import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Select, MenuItem, FormControl, FormControlLabel, RadioGroup, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import ApiService from "../../../functions/apiService";

export default function OvertimeDetailHours()
{
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const onSubmit = () => {
        setLoading(true);
        ApiService.post('/zeroAllHours', []).then(( data ) => {
            setLoading(false);
            console.log('data', data);
            enqueueSnackbar('success', { variant: 'success' });
        }).catch(({ data }) => {
            setLoading(false);
            if(data.message){
                enqueueSnackbar(data.message, { variant: "success" });
            }else{
                enqueueSnackbar('success', { variant: 'success' });
            }
        });
    }
    const onSubmit1 = () => {
        console.log('body1');
    }
    const onSubmit2 = () => {
        console.log('body2');
    }
    const onSubmit3 = () => {
        setLoading(true);
        ApiService.post('/ClearDataOvertime', []).then(( data ) => {
            setLoading(false);
            console.log('data', data);
            if(data.message){
                enqueueSnackbar(data.message, { variant: "success" });
            }else{
                enqueueSnackbar('success', { variant: 'success' });
            }
        }).catch(({ data }) => {
            setLoading(false);
            enqueueSnackbar('Error', { variant: 'error' });
        });
    }
    const onSubmit4 = () => {
        setLoading(true);
        ApiService.post('/postNFIRS', []).then(( data ) => {
            setLoading(false);
            console.log('data', data);
            if(data.message){
                enqueueSnackbar(data.message, { variant: "success" });
            }else{
                enqueueSnackbar('success', { variant: 'success' });
            }
        }).catch(({ data }) => {
            setLoading(false);
            enqueueSnackbar('Error', { variant: 'error' });
        });
    }
    return <>
        <Typography fontWeight='700' fontSize="16px">Reset to Zero</Typography>
        <div className="col-12 my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit} color='primary'>Zero Hours</ButtonTheme>
        </div>
        {/* <Typography fontWeight='500' fontSize="20px">Recalc Hours</Typography>
        <div className="col-12  my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit1} color='primary'>Recalc Hours</ButtonTheme>
        </div> */}
        {/* <Typography fontWeight='500' fontSize="20px">Populate Overtime Lists</Typography>
        <div className="col-12  my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit2} color='primary'>Regular Button</ButtonTheme>
        </div> */}
        <hr />
        <Typography fontWeight='700' fontSize="16px">Clear All Dynamic</Typography>
        <div className="col-12  my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit3} color='primary'>Clear Data</ButtonTheme>
        </div>
        <hr />
        {/* <Typography fontWeight='600' fontSize="20px">Update Hours</Typography>
        <div className="col-12  my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit3} color='primary'>Update Hours</ButtonTheme>
        </div>
        <hr /> */}
        <Typography fontWeight='700' fontSize="16px">NFIRS</Typography>
        <div className="col-12  my-3">
            <ButtonTheme disabled={loading} onClick={onSubmit4} color='primary'>NFIRS</ButtonTheme>
        </div>

    </>
}
